export const privacyPolicy = `# Privacy Policy

Last updated: ${new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}

## 1. Introduction

Tier One Analytics, Inc. ("we", "us", or "our") operates the Alchemist web portal ("Service"). This Privacy Policy explains how we collect, use, and protect your information when you use our Service.

## 2. Information We Collect

### 2.1 Account Information
- Email address
- Username
- API keys (stored in encrypted form)

### 2.2 Content Data
- Files you upload for analysis or conversion
- Metadata about your files (size, type, upload time)
- Analysis results and converted files

### 2.3 Usage Data
- Log data (IP address, browser type, access times)
- Service usage patterns
- Error reports and performance data

## 3. How We Use Your Information

We use your information solely to:
- Provide and maintain the Service
- Process your files for analysis or conversion
- Communicate with you about the Service
- Ensure security and prevent fraud
- Comply with legal obligations

## 4. Data Processing and Storage

### 4.1 File Processing
By using our Service, you agree to transfer your files to our servers for processing. We implement the following security measures:

- **Encryption in Transit**: All files are encrypted using industry-standard SSL/TLS protocols during upload and download
- **Encryption at Rest**: Files are encrypted using AES-256 encryption while stored on our servers
- **Temporary Storage**: Uploaded files are stored only during the analysis process and are automatically deleted once the analysis is complete
- **Results Storage**: Analysis artifacts are stored encrypted on our servers until you explicitly delete them

### 4.2 Data Retention
- Uploaded files: Deleted immediately after processing
- Analysis results: Retained until you delete them
- Account information: Retained while your account is active
- Logs: Retained for 30 days for security and debugging purposes

## 5. Data Security

We implement appropriate technical and organizational measures to protect your data:
- Industry-standard encryption protocols
- Access controls and authentication systems
- Regular security audits and monitoring
- Secure data centers with physical security controls

## 6. Data Sharing

We do not sell, trade, or rent your personal information. We may share your information only:
- With your explicit consent
- To comply with legal obligations
- To protect our rights and prevent fraud
- With service providers who assist in operating our Service (under strict confidentiality agreements)

## 7. Your Rights

You have the right to:
- Access your personal information
- Correct inaccurate data
- Delete your account and associated data
- Export your data
- Opt-out of non-essential communications

## 8. Cookies

We use essential cookies to maintain your session and provide the Service. We do not use tracking or advertising cookies.

## 9. Third-Party Services

Our Service may contain links to third-party services. We are not responsible for the privacy practices of these services.

## 10. Children's Privacy

Our Service is not intended for children under 18. We do not knowingly collect information from children.

## 11. Changes to Privacy Policy

We may update this Privacy Policy from time to time. We will notify you of any material changes by updating the date at the top of this policy.

## 12. Contact Us

If you have questions about this Privacy Policy, please contact us at:
- Email: office@getalchemist.io
- Address: Tier One Analytics, Inc., 1751 Pinnacle Dr #600 McLean VA 22102 USA

By using the Alchemist Service, you acknowledge that you have read and understood this Privacy Policy.`;
